import { DebitOrCreditEnum } from "@/lib/enum/debit-or-credit.enum";
import { Filter, IsFilterable, FilterConfig, FilterTypes } from "@/lib/filterable";
import {
  MrfiktivInvoiceBookingEntryDtoGen,
  MrfiktivInvoiceBookingEntryViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
class InvoiceBookingEntryBase implements MrfiktivInvoiceBookingEntryViewModelGen {
  /** Description of the booking entry */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceBookingEntry.description"
  })
  description: string;

  /** Amount of the booking entry */
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.invoiceBookingEntry.amount"
  })
  amount: number;

  /** Account associated with the booking entry */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.invoiceBookingEntry.account"
  })
  account: string;

  /** Type of the booking entry (Debit or Credit) */
  @FilterConfig({
    type: FilterTypes.ENUM,
    displayName: "objects.invoiceBookingEntry.type"
  })
  type: DebitOrCreditEnum;

  constructor(data?: MrfiktivInvoiceBookingEntryViewModelGen | IInvoiceBookingEntry) {
    this.description = data?.description || "";
    this.amount = data?.amount || 0;
    this.account = data?.account || "";
    this.type = (data?.type as DebitOrCreditEnum) || DebitOrCreditEnum.CREDIT;
  }

  get dto(): MrfiktivInvoiceBookingEntryDtoGen {
    return {
      account: this.account,
      amount: this.amount,
      description: this.description,
      type: this.type
    };
  }
}

type IInvoiceBookingEntry = InvoiceBookingEntryBase;
const InvoiceBookingEntry = Filter.createForClass(InvoiceBookingEntryBase);

export { IInvoiceBookingEntry, InvoiceBookingEntry };
